import { render, staticRenderFns } from "./StateCenterCom.vue?vue&type=template&id=2f10e9ba&scoped=true"
import script from "./StateCenterCom.vue?vue&type=script&lang=js"
export * from "./StateCenterCom.vue?vue&type=script&lang=js"
import style0 from "./StateCenterCom.vue?vue&type=style&index=0&id=2f10e9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f10e9ba",
  null
  
)

export default component.exports